import React, { useEffect, useRef } from 'react';
import './Hero.css';

export default function Hero({ t }) {
  const particlesRef = useRef(null);

  useEffect(() => {
    const canvas = particlesRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let w = canvas.width = window.innerWidth;
    let h = canvas.height = window.innerHeight;

    const embers = Array.from({ length: 180 }, () => ({
      x: Math.random() * w,
      y: Math.random() * h,
      r: Math.random() * 3.2 + 0.4,
      dx: (Math.random() - 0.5) * 1.6,
      dy: -(Math.random() * 1.8 + 0.4),
      wobble: Math.random() * Math.PI * 2,   // phase offset for lateral wobble
      wobbleSpeed: 0.04 + Math.random() * 0.08,
      wobbleAmp: 0.5 + Math.random() * 1.8,  // how far sideways they drift
      alpha: Math.random(),
      fade: Math.random() * 0.006 + 0.0015,
    }));

    let raf;
    function draw() {
      ctx.clearRect(0, 0, w, h);
      embers.forEach(e => {
        ctx.save();
        ctx.globalAlpha = e.alpha;
        // colour shifts: bright orange → deep red as they fade
        const hot = e.alpha > 0.65;
        ctx.fillStyle = hot ? '#ff8020' : e.alpha > 0.35 ? '#e8400a' : '#c0002a';
        ctx.shadowBlur = hot ? 10 : 5;
        ctx.shadowColor = hot ? '#ff6010' : '#c0002a';
        ctx.beginPath();
        ctx.arc(e.x, e.y, e.r, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();

        // chaotic lateral wobble
        e.wobble += e.wobbleSpeed;
        e.x += e.dx + Math.sin(e.wobble) * e.wobbleAmp;
        e.y += e.dy;
        e.alpha -= e.fade;

        if (e.alpha <= 0 || e.y < -40) {
          // respawn near the bottom, spread across full width + a bit beyond
          e.x = -50 + Math.random() * (w + 100);
          e.y = h + 20;
          e.alpha = Math.random() * 0.7 + 0.3;
          e.dx = (Math.random() - 0.5) * 1.6;
          e.dy = -(Math.random() * 1.8 + 0.4);
          e.wobbleSpeed = 0.04 + Math.random() * 0.08;
          e.wobbleAmp = 0.5 + Math.random() * 1.8;
        }
      });
      raf = requestAnimationFrame(draw);
    }
    draw();

    const onResize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    window.addEventListener('resize', onResize);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <section id="home" className="hero">
      <canvas ref={particlesRef} className="hero-canvas" />
      <div className="hero-overlay" />

      <div className="hero-content">
        <p className="hero-inscription">{t.inscription}</p>
        <p className="hero-eyebrow">✦ &nbsp; M A S T E R &nbsp; ✦</p>
        <h1 className="hero-title">DANTE</h1>
        <p className="hero-role">{t.role}</p>
        <p className="hero-subtitle">{t.subtitle}</p>
        <div className="hero-rule" />
        <p className="hero-tagline">{t.tagline}</p>
        <a href="#about" className="hero-cta">{t.cta}</a>
      </div>

      <div className="hero-scroll-hint">
        <span />
      </div>
    </section>
  );
}
